import React from "react";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import { CalendarOutlined } from "@ant-design/icons";

const RangePicker = () => {
  const { RangePicker } = DatePicker;
  function onChange(date, dateString) {
    console.log(date, dateString);
  }
  return (
    <>
      <section className="range-picker ">
        <div >
          <CalendarOutlined  className="calendar-icon"/>
        </div>
        <div className="range-picker-modal">
          <RangePicker onChange={onChange} />
        </div>
        <button className="clear-btn">clear</button>
      </section>
    </>
  );
};

export default RangePicker;
